import { render, staticRenderFns } from "./AppHomeowner.vue?vue&type=template&id=531c3d2f&"
import script from "./AppHomeowner.vue?vue&type=script&lang=js&"
export * from "./AppHomeowner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports